import request from '@/utils/request'

export default {
  // 接口列表
  getInterface(params) {
    return request({
      url: '/console/apis',
      method: 'GET',
      params
    })
  },
  // 接口详情
  getInterfaceDetail(id) {
    return request({
      url: `/console/apis/${id}`,
      method: 'GET'
    })
  },
  // 接口添加
  addInterface(params) {
    return request({
      url: '/console/apis',
      method: 'POST',
      data: params
    })
  },
  // 接口编辑
  editInterface(id, params) {
    return request({
      url: `/console/apis/${id}`,
      method: 'PUT',
      data: params
    })
  }
}
